.image {
  background-color: transparent;
  border-radius: var(--logo-image-radius);
  display: block;
  height: auto;
  max-height: var(--logo-image-max-height);
  max-width: var(--logo-image-max-width);
  object-fit: contain;
  width: auto;
}
